import { error, finish } from '../../../modules/selections/actions/settle';
import { request as refreshEvent } from '../../../modules/events/actions/get';
import api from '../../../api';

let updates = {};

function settleSelection(dispatch, id, eventId, marketId) {
    let promise = api.post(`/events/${eventId}/markets/${marketId}/selections/${id}/settle`).then(
        selection => {
            promise.resolved = true;
            dispatch(finish(id, selection));
            dispatch(refreshEvent(eventId));
        },
        errors => {
            promise.resolved = true;
            dispatch(error(id, errors.body));
        }
    );

    return promise;
}

export function request(dispatch, { id, eventId, marketId }) {
    let update = () => settleSelection(dispatch, id, eventId, marketId);

    if (updates[eventId] && !updates[eventId].resolved) {
        updates[eventId] = updates[eventId].then(update, update);
    } else {
        updates[eventId] = update();
    }
}
